/* eslint-disable import/no-named-as-default */
import EnforceLogin from './EnforceLogin';

export default EnforceLogin;
